import { FC } from "react";
import { CompetitionContainer } from "./styled";
import { CompetitionCard } from "./CompetitionCard";
import { Competition } from "@brg/api";
import { ExtraGridConditionType } from "shared/pages/opencallsPage/GetCompetitionItem/types/extraGridConditionType";

const CompetitionGrid: FC<{ competitions: Competition[], isProfile?: boolean, isMainPage?: boolean, extraGridCondition: ExtraGridConditionType, notClickableTags?: boolean }> = ({ notClickableTags, competitions, isProfile, extraGridCondition, isMainPage }) => {

  return (
    <CompetitionContainer isProfile={isProfile} extraGridCondition={extraGridCondition}>
      {competitions
        .map((competitionProps) => {
            return (
              <CompetitionCard
                key={competitionProps?.competitionId}
                isNewType
                notClickableTags={notClickableTags}
                extraGridCondition={extraGridCondition}
                isProfile={isProfile}
                competitionProps={competitionProps}
                isMainPage={isMainPage}
              />
            )
          }
        )}
    </CompetitionContainer>
  )
}

export default CompetitionGrid;import { FC } from "react";
import { CompetitionContainer } from "./styled";
import { CompetitionCard } from "./CompetitionCard";
import { Competition } from "@brg/api";
import { ExtraGridConditionType } from "shared/pages/opencallsPage/GetCompetitionItem/types/extraGridConditionType";

const CompetitionGrid: FC<{ competitions: Competition[], isProfile?: boolean, isMainPage?: boolean, extraGridCondition: ExtraGridConditionType, notClickableTags?: boolean }> = ({ notClickableTags, competitions, isProfile, extraGridCondition, isMainPage }) => {

  return (
    <CompetitionContainer isProfile={isProfile} extraGridCondition={extraGridCondition}>
      {competitions
        .map((competitionProps) => {
            return (
              <CompetitionCard
                key={competitionProps?.competitionId}
                isNewType
                notClickableTags={notClickableTags}
                extraGridCondition={extraGridCondition}
                isProfile={isProfile}
                competitionProps={competitionProps}
                isMainPage={isMainPage}
              />
            )
          }
        )}
    </CompetitionContainer>
  )
}

export default CompetitionGrid;